/**
 * What the user is looking at, so "why is this wrong?" resolves without them naming anything.
 * Derived from the route rather than threaded through props, so any page gets it for free.
 */
/**
 * Entity pages in this app are query based, not REST style: /edit_property?id=..., not
 * /properties/<id>. The original patterns assumed the latter, so they never matched a real page
 * and the drawer never knew what the reader was looking at.
 *
 * The nested dashboard route is the exception: it carries ids as path segments.
 */
const ROUTE_ENTITY = [{
  match: /^\/edit_property\b/,
  entityType: 'property',
  param: 'id'
}, {
  match: /^\/new_property\b/,
  entityType: 'property',
  param: 'id'
}, {
  match: /^\/resident_acount\b/,
  entityType: 'resident',
  param: 'id'
}, {
  match: /^\/residencies\b/,
  entityType: 'resident',
  param: 'id'
}, {
  match: /^\/allocation_tables\b/,
  entityType: 'allocation',
  param: 'id'
}, {
  match: /^\/bills\b/,
  entityType: 'bill',
  param: 'id'
},
// /active_dashboard/:company/:portfolio/:property, which is where a search result lands.
{
  match: /^\/active_dashboard\/[\w-]+\/[\w-]+\/([\w-]+)/,
  entityType: 'property'
}];
export function derivePageContext(pathname) {
  var _params$get;
  let search = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  let companyId = arguments.length > 2 ? arguments[2] : undefined;
  const params = new URLSearchParams(search);
  const context = {
    route: pathname
  };
  if (companyId) context.companyId = companyId;
  for (const _ref of ROUTE_ENTITY) {
    const match = _ref.match;
    const entityType = _ref.entityType;
    const param = _ref.param;
    const found = pathname.match(match);
    if (!found) continue;
    const id = param ? params.get(param) : found[1];
    if (!id) continue; // the page without a record is not a record page
    context.entityType = entityType;
    context.entityId = id;
    break;
  }

  // Reporting keys everything off a cycle, and the wrong cycle is the classic way to read $0.00
  // and believe it, so it travels with the question.
  const cycleId = (_params$get = params.get('allocationCycleId')) !== null && _params$get !== void 0 ? _params$get : params.get('cycleId');
  if (cycleId) context.cycleId = cycleId;
  const propertyId = params.get('propertyId');
  if (propertyId) context.propertyId = propertyId;
  return context;
}